import { Children } from 'react'
import PropTypes from 'prop-types'
import Type from 'components/Type'
import Icon from 'components/Icon'
import Badge from '@mui/material/Badge'
import Stack from '@mui/material/Stack'

const IconList = ({
  children,
  icon,
  icons,
  align,
  font,
  ...props
}) => (
    <Stack
      gap={2}
      {...props}
    >
      {Children.map(children, (child, idx) => !!child && (
        <Stack
          sx={theme => theme.internalMixins.columns({ gap: 1, align })}
          gridTemplateColumns="auto 1fr"
        >
          {(icon || icons) && <Icon icon={icon || icons?.[idx]} />}
          {!icon && !icons && <Badge className="static" color="secondary" badgeContent={idx + 1} />}
          <Type
            variant={font}
            mt={align === 'flex-start' ? .2 : 0}
          >
            {child}
          </Type>
        </Stack>
      ))}
    </Stack>
  )

IconList.propTypes = {
  icon: PropTypes.string,
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  font: PropTypes.string,
}

IconList.defaultProps = {
  align: 'center',
  font: 'dataSmall',
}

export default IconList